export default "__VITE_ASSET__DmeO8tWu__"